<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-80 start-project">
        <md-card class="">
          <form>
          <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>group</md-icon>
            </div>
            <h4 class="title">
              Add a New User
            </h4>
          </md-card-header>
          <md-card-content class="content-inputs">
            <div class="md-layout start-inputs">
              <md-field class="md-layout-item md-size-45 md-medium-size-100">
                <label>First Name</label>
                <md-input v-model="newUser.first_name" required type="text"></md-input>
              </md-field>
              <md-field class="md-layout-item md-size-45 md-medium-size-100">
                <label>Last Name</label>
                <md-input v-model="newUser.last_name" required type="text"></md-input>
              </md-field>
              <md-field class="md-layout-item md-size-100">
                <label>Email</label>
                <md-input v-model="newUser.email" type="text"></md-input>
              </md-field>
              <md-field class="md-layout-item md-size-45">
                <label>Phone Number</label>
                <md-input v-model="newUser.phone_number" type="text"></md-input>
              </md-field>
              <md-field class="md-layout-item md-size-45">
                <!-- <label>Owner or Employee?</label> -->
                <!-- <label>Owner or Employee</label> -->
                <md-select v-model="newUser.uType">
                  <md-option value="owner">Admin</md-option>
                  <md-option value="employee">Employee</md-option>
                </md-select>
              </md-field>
              <md-field class="md-layout-item md-size-45" style="padding-top: 10px;">
                <label>GPR Access</label>
                <md-select v-model="newUser.gpr_access">
                  <md-option value="true">Yes</md-option>
                  <md-option value="false">No</md-option>
                </md-select>
              </md-field>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="right">
            <md-button class="md-success" v-on:click="addUser">Add New User</md-button>
          </md-card-actions>
        </form>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api';

export default {
  data() {
    return {
      newUser: {
        first_name: '',
        last_name: '',
        email: '',
        uType: 'owner',
        phone_number: '',
        gpr_access: true
      },
    }
  },
  methods: {
    addUser() {
      api.inviteNewUserByAdmin(this.newUser).then((response) => {
        this.notifyVue(`Thank you for adding a new user; ${this.newUser.email} has been saved.`);
        this.$router.push("users")
      })
    },
    notifyVue(message) {
      this.$notify({
        timeout: 2500,
        message: message,
        icon: "done_all",
        horizontalAlign: "left",
        verticalAlign: "top",
        type: "success"
      });
    },
  }
};
</script>
<style lang="scss">
  .radio {
    .md-radio {
      // position: relative;
      display: flex;
      // padding: 0 20px;
      align-items: center;
      justify-content: flex-start;
      .md-radio-container {
        // vertical-align: center;
        // align-items: center;
      }
      .md-radio-label {
        // align-items: center;
        // height: 40px;
        padding-left: 10px;
        // position: static;
        line-height: 10px;
      }
    }
  }
</style>
